import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Banner } from '@yonderland/andes-react';
import { LightbulbIcon } from '@yonderland/andes-icons';
import AsNumeral from '../../../vendors/asNumeral';
const MESSAGE_AMOUNT_TEMPLATE = '{{{AMOUNT}}}';
export const ClosenessQualifier = ({ amountUntilFreeDelivery, totalPriceSell, showProgressBar, freeDeliveryMessage, }) => {
    const { currency } = useAemConfig();
    return (_jsx(Banner, { testId: "closeness_qualifier", status: "informative", icon: { source: LightbulbIcon }, progress: showProgressBar ? (totalPriceSell / (totalPriceSell + amountUntilFreeDelivery)) * 100 : undefined, text: freeDeliveryMessage.replace(MESSAGE_AMOUNT_TEMPLATE, `${currency}${AsNumeral.formatAsCurrency(amountUntilFreeDelivery)}`) }));
};
